import {GetNotificationsSettingsCommand, type GetNotificationsSettingsResponse} from '@perfectpost/perfect-post-common';
import {useQuery} from '@tanstack/react-query';

import {sendOrThrow} from '../../../services/sendOrThrow';
import {notificationKeys} from '../keys';

/**
 * Réglages d'e-mails de l'utilisateur.
 *
 * Remplace les `send(new GetNotificationsSettingsCommand())` écrits dans un
 * `useEffect` + `useState` de `Profile` et de `LoginRequiredRoute`. Un
 * utilisateur qui n'a jamais enregistré ses réglages reçoit un document sans
 * `_id` : c'est ce que `LoginRequiredRoute` lit pour ouvrir le dialogue.
 */
export function useNotificationsSettingsQuery(options?: {enabled?: boolean}) {
  return useQuery({
    queryKey: notificationKeys.settings(),
    queryFn: (): Promise<GetNotificationsSettingsResponse> => sendOrThrow(new GetNotificationsSettingsCommand()),
    enabled: options?.enabled ?? true,
  });
}
